import { Action } from "@ptl/state";
import { SavedQuotesStateStructure } from "../interfaces/savedQuotesStateStructure.interface";
import { SaveQuoteMetaData } from "../interfaces/save-quote-data.interface";
import { ENROLLMENT_FLOW } from "src/app/angular-elements/form-wrappers/plan-enrollment/individual-plan-enrollment-form/configs/interfaces/enrollment-flow.enum";
import { ENROLLMENT_CHANNEL } from "src/app/angular-elements/shared/interfaces/enrollment-submission.interface";

const INITIAL_STATE: SavedQuotesStateStructure = {
    saveQuoteFlowActivated: false,
    enrollmentFlow: null,
    enrollmentChannel: null,
    referralId: null,
    producerInd: null,
    authorized: false,
    saveQuoteData: null,
    saveQuoteName: null
}

const SAVE_SAVED_QUOTES = 'SAVE_SAVED_QUOTES';
const IS_DOB_AUTHORIZED = 'IS_DOB_AUTHORIZED';
const SAVE_ENROLLMENT_FLOW = 'SAVE_ENROLLMENT_FLOW';

export class SavedQuotesAction implements Action {
    type: string;
    enrollmentFlow?: ENROLLMENT_FLOW;
    enrollmentChannel?: ENROLLMENT_CHANNEL;
    referralId?: string | null;
    producerInd?: boolean;
    authorized?: boolean;
    saveQuoteData?: SaveQuoteMetaData;
    saveQuoteName?: string;
}

export function saveSavedQuotes(data: {
    enrollmentChannel: ENROLLMENT_CHANNEL;
    enrollmentFlow: ENROLLMENT_FLOW;
    referralId: string | null;
    producerInd: boolean;
    saveQuoteName: string;
    saveQuoteData: SaveQuoteMetaData;
}): SavedQuotesAction {
    return {
        type: SAVE_SAVED_QUOTES,
        enrollmentChannel: data.enrollmentChannel,
        enrollmentFlow: data.enrollmentFlow,
        referralId: data.referralId,
        producerInd: data.producerInd,
        saveQuoteName: data.saveQuoteName,
        saveQuoteData: data.saveQuoteData
    };
}

export function isDobAuthorized(authorized: boolean): SavedQuotesAction {
    return {type: IS_DOB_AUTHORIZED, authorized};
}

export function saveEnrollmentFlow(enrollmentFlow: ENROLLMENT_FLOW){
  return {type: SAVE_ENROLLMENT_FLOW, enrollmentFlow};
}
export const SAVED_QUOTES_REDUCER_NAME = 'SavedQuotes';

export function SavedQuotes(
    state: SavedQuotesStateStructure = INITIAL_STATE,
    action: SavedQuotesAction
) {
    const copiedState: SavedQuotesStateStructure = JSON.parse(JSON.stringify(Object.assign({}, state)));

    switch (action.type) {
        case SAVE_SAVED_QUOTES: 
            copiedState.saveQuoteFlowActivated = true;
            copiedState.enrollmentChannel = action.enrollmentChannel;
            copiedState.enrollmentFlow = action.enrollmentFlow;
            copiedState.referralId = action.referralId;
            copiedState.producerInd = action.producerInd;
            copiedState.saveQuoteName = action.saveQuoteName;
            copiedState.saveQuoteData = action.saveQuoteData;
            return Object.assign({}, state, copiedState);
        case IS_DOB_AUTHORIZED: 
            copiedState.authorized = action.authorized;
            return Object.assign({}, state, copiedState);
        case SAVE_ENROLLMENT_FLOW:
            copiedState.enrollmentFlow = action.enrollmentFlow;
            return Object.assign({}, state, copiedState);
        default: 
            return state;
    }
}
